import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {AgreementType, LeaseStatus, LeaseViewSection, OccupancyType} from "@features/leasing/leasing.model";
import {ResponsiveDrawerComponent} from "@shared-components/responsive-drawer/responsive-drawer.component";
import {LeaseViewService} from "../../../lease-view/lease-view.service";

@Component({
  selector: 'app-lease-details-drawer',
  templateUrl: './lease-details-drawer.component.html'
})
export class LeaseDetailsDrawerComponent implements OnInit {
  @Input() leaseId!: string;
  @Output() updateLeaseStatus = new EventEmitter<void>();

  leaseData: {
    id: string,
    occupancyType: OccupancyType,
    agreementType: AgreementType,
    hiddenSections: LeaseViewSection[],
    embedded: boolean
  } | null = null;

  constructor(private leaseViewService: LeaseViewService,
              @Inject(ResponsiveDrawerComponent) public responsiveDrawer: ResponsiveDrawerComponent) {
  }

  ngOnInit() {
    this.leaseViewService.getOne(``, this.leaseId).subscribe({
      next: value => {
        this.leaseData = {
          id: value.uuid,
          occupancyType: value.occupancyType!,
          agreementType: value.agreementType!,
          hiddenSections: [LeaseViewSection.HEADER, LeaseViewSection.DOCUMENTS, LeaseViewSection.POINT_OF_SALE, LeaseViewSection.TURNOVER],
          embedded: true
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }
}
